const state = () => ({
  language: 'eng',
});

const mutations = {
  setLanguage(state, language) {
    state.language = language;
  },
};

const actions = {
  setLanguage({commit}, language) {
    commit('setLanguage', language);
  },
};

const getters = {
  language(state) {
    return state.language;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
